import { render, staticRenderFns } from "./reSubmit.vue?vue&type=template&id=ac63d16e&scoped=true&"
import script from "./reSubmit.vue?vue&type=script&lang=js&"
export * from "./reSubmit.vue?vue&type=script&lang=js&"
import style0 from "../../static/oa-img/css/index.css?vue&type=style&index=0&id=ac63d16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac63d16e",
  null
  
)

export default component.exports